module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "point-block"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._m(2), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                    Солнечная Сицилия\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                    Сицилийские цитрусовые занимают важное место на рынке европейских...\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openPopup($event)
      }
    }
  }, [_vm._v("\n                    Смотреть\n                    "), _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 87.2 65.2"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 87.2 65.2",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2\n                                    l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2\n                                    c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point4/img.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-over point-img4"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point4/img-over.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Солнечная Сицилия — очень красивый и разнообразный остров, омываемый тремя морями, который подарил мне редкую возможность полного слияния с природой\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Сицилия, Италия\n                    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6335841f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/points/point4.vue
// module id = 542
// module chunks = 1